import React, { useMemo } from 'react';
import GenericTableFilter from '../../../components/common/GenericTableFilter';
import { getYesterdayDate, parseLocalDate } from '../../../utils/dateUtils';

const ShipmentDeliveryFilter = ({ filterFields, columns, dateRange, filterUiKey = 0, handleApplyFilters, handleResetFilters }) => {
    const initialFilters = useMemo(() => {
        const f = {};
        (filterFields || []).forEach((ff) => (f[ff.field] = ''));
        f.startDate = parseLocalDate(dateRange?.startDate) || getYesterdayDate();
        f.endDate = parseLocalDate(dateRange?.endDate) || '';
        return f;
    }, [filterFields, dateRange]);

    return (
        <GenericTableFilter
            key={`${filterUiKey}-${dateRange?.startDate || ''}-${dateRange?.endDate || ''}`}
            filterFields={filterFields}
            columns={columns}
            initialFilters={initialFilters}
            onSearch={() => {}}
            onApplyFilters={handleApplyFilters}
            onResetFilters={handleResetFilters}
            customFilterTypes={{}}
            customFilterOptions={{}}
            initiallyOpen={true}
        />
    );
};

export default ShipmentDeliveryFilter;
